import React, { useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import { CentredSpinner } from "@velove/design-system";
import { AppContext } from "../contexts/AppContext";
import Navbar from "../components/Navbar";
import Home from "./Home";
import { DeliveryStatusType } from "../contexts/contextTypes";

const Main = () => {
  const { packageId } = useParams();
  const { pathname } = useLocation();
  const {
    isCustomerInputsOpen,
    bankId,
    setTrackingDetails,
    trackingDetails,
    isPolling,
    setPollingStatus,
    setBankIdOderRef,
  } = useContext(AppContext);
  dayjs.extend(calendar);
  const splitPath = pathname.split("/")[1];

  const removeOrderRefFromUrl = () => {
    // Get the current URL without the query string
    const urlWithoutQuery =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    // Update the URL without the query string
    window.history.replaceState({}, document.title, urlWithoutQuery);
  };

  useQuery({
    queryKey: ["trackingDetails", packageId],
    queryFn: async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/package/${packageId}`,
        {
          params: {
            from: splitPath === "p" ? "consumer" : "support",
          },
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      const urlParams = new URLSearchParams(window.location.search);
      const orderRef = urlParams.get("orderref");

      if (orderRef) {
        setBankIdOderRef(orderRef);
        removeOrderRefFromUrl();
      }

      const predictedArrival = data?.eta?.predictedArrival || null;
      const trackingEvents = data?.trackingEvents || [];

      const index = trackingEvents.findIndex(
        (event: { eventNo: number; datetime: Date }) => event.eventNo === 5
      );

      if (index > -1 && predictedArrival) {
        const deliveryDiff = dayjs(predictedArrival).diff(dayjs(), "minute");

        if (deliveryDiff <= 3) {
          trackingEvents.splice(index, 0, {
            eventNo: 5.3,
            datetime: dayjs(predictedArrival).subtract(3, "minute").toDate(),
          });
        }
      }

      setTrackingDetails(data);
      if (!isPolling) setPollingStatus();

      const savedScrollPosition = localStorage.getItem("scrollPosition");
      if (savedScrollPosition) {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
      }
    },
    onError: () => {
      console.log("Fetching tracking details failed");
    },
    refetchInterval:
      trackingDetails?.task?.status === DeliveryStatusType.COMPLETED
        ? 0 // Disable refetch interval if completed, but do not disable query
        : 30000, // Re-fetch the data every 30 seconds
    enabled:
      !!packageId &&
      ((splitPath === "p" && !isCustomerInputsOpen) || splitPath === "cs") &&
      !bankId.orderRef,
  });

  return (
    <Navbar>
      {isPolling ? (
        <Home />
      ) : (
        <div className="loader_container">
          <CentredSpinner size="80" className="inner_loader" />
        </div>
      )}
    </Navbar>
  );
};

export default Main;
